import { useState } from "react";
import LoginImage from "../assest/images/Bg_Login.jpg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { toggleModal, openModal } from "../Redux/modalSlice";
import apiInstance from "../apiConfig/apiinstance";

function ResetSystemGeneratedPassword() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [systemPassword, setSystemPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  // Eye toggle states
  const [showSystemPassword, setShowSystemPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("New Password and Confirm Password do not match.");
      return;
    }

    const payload = {
      username,
      old_password: systemPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    };

    setLoading(true);
    try {
      const { data } = await apiInstance.post(
        `/api/auth/v1/change-system-password/`,
        payload
      );
      if (data.status === 200) {
        toast.success("Password reset successful. Please login.");
        navigate("/");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error resetting password");
    } finally {
      setLoading(false);
    }
  };
  function handleclick() {
    dispatch(openModal());
    navigate("/");
  }
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 relative">
      <img
        src={LoginImage}
        alt="login-bg"
        className="w-full h-full absolute top-0 left-0 object-cover opacity-50"
      />
      <form
        onSubmit={handlePasswordReset}
        className="bg-white md:p-8 p-4 rounded shadow-md w-full m-2 z-10 md:text-2xl md:max-w-[35rem]"
      >
        <h2 className="text-2xl font-bold mb-6 text-center">Reset Password</h2>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          style={{ fontFamily: "sans-serif" }}
          className="w-full mb-4 p-3 border border-gray-300 rounded"
        />

        {/* System Generated Password with Eye */}
        <div className="relative w-full mb-4">
          <input
            type={showSystemPassword ? "text" : "password"}
            placeholder="System Generated Password"
            value={systemPassword}
            onChange={(e) => setSystemPassword(e.target.value)}
            required
            style={{ fontFamily: "sans-serif" }}
            className="w-full p-3 border border-gray-300 rounded"
          />
          <button
            type="button"
            onClick={() => setShowSystemPassword(!showSystemPassword)}
            className="absolute inset-y-0 right-3 flex items-center"
            style={{
              background: "transparent",
              color: "black",
              fontSize: "25px",
            }}
          >
            {showSystemPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        {/* New Password with Eye */}
        <div className="relative w-full mb-4">
          <input
            type={showNewPassword ? "text" : "password"}
            placeholder="New Password"
            value={newPassword}
            style={{ fontFamily: "sans-serif" }}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="w-full p-3 border border-gray-300 rounded"
          />
          <button
            type="button"
            onClick={() => setShowNewPassword(!showNewPassword)}
            className="absolute inset-y-0 right-3 flex items-center"
            style={{
              background: "transparent",
              color: "black",
              fontSize: "25px",
            }}
          >
            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        {/* Confirm New Password with Eye */}
        <div className="relative w-full mb-4">
          <input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm New Password"
            value={confirmPassword}
            style={{ fontFamily: "sans-serif" }}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="w-full p-3 border border-gray-300 rounded"
          />
          <button
            type="button"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            className="absolute inset-y-0 right-3 flex items-center"
            style={{
              background: "transparent",
              color: "black",
              fontSize: "25px",
            }}
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700 transition disabled:bg-gray-400`}
        >
          {loading ? "Processing..." : "Reset Password"}
        </button>

        <div className="mt-4 text-center">
          <a
            onClick={() => handleclick()}
            className="text-sm text-blue-600 hover:underline"
          >
            Back to Login
          </a>
        </div>
      </form>
    </div>
  );
}

export default ResetSystemGeneratedPassword;
